import ProductOptionsActionTypes from '../actionTypes/ProductOptionsActionTypes';

const ProductOptionsReducer = function ProductOptionsReducer(state = {}, action) {
    switch (action.type) {
        case ProductOptionsActionTypes.PRODUCTOPTIONS_ON_CHANGE:
            return { ...action.payload, priceType: action.priceType };
        case ProductOptionsActionTypes.PRODUCTOPTIONS_ON_RESET:
            return {};
        case ProductOptionsActionTypes.PRODUCTOPTIONSBUNDLE_ON_CHANGE:
            return action.payload;
        default:
            return state;
    }
};

// ProductOptionsReducer.reducerName = 'productOptions';

export default ProductOptionsReducer;
